import * as React from "react";
import { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_834_3427)">
      <path
        d="M14.1667 2.5C14.3856 2.28113 14.6454 2.10751 14.9314 1.98906C15.2173 1.87061 15.5238 1.80964 15.8334 1.80964C16.1429 1.80964 16.4494 1.87061 16.7353 1.98906C17.0213 2.10751 17.2812 2.28113 17.5 2.5C17.7189 2.71887 17.8925 2.97871 18.011 3.26467C18.1294 3.55064 18.1904 3.85714 18.1904 4.16667C18.1904 4.4762 18.1294 4.78269 18.011 5.06866C17.8925 5.35463 17.7189 5.61446 17.5 5.83333L6.25002 17.0833L1.66669 18.3333L2.91669 13.75L14.1667 2.5Z"
        stroke="#556987"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_834_3427">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgComponent;
